// hooks/rateHooks.ts
import { useMutation } from '@tanstack/react-query';
import { rateService } from '../services/rate';
import { RateRequest, RateResponse } from '../types/rate';

// Query keys
export const rateKeys = {
  all: ['rates'] as const,
  calculation: () => [...rateKeys.all, 'calculation'] as const,
};

export const useCalculateRates = () => {
  return useMutation<
    RateResponse[], 
    Error, 
    { userId: string; rateData: RateRequest }
  >({
    mutationFn: ({ userId, rateData }) =>
      rateService.calculateRates(userId, rateData),
    onError: (error: Error) => {
      console.error('Rate calculation error:', error);
    },
  });
};